// Lønnskjøring (en).
window.PlummeI18n.register('en', {
  // ---------------------------------------------------- Payroll run
  'pay.overview': 'Payroll overview',
  'pay.overviewSub': 'Registered pay for the financial year, grouped by employee.',
  'pay.noPayBasis': 'No pay basis yet',
  'pay.noPayBasisHint': 'The overview appears once payroll runs are approved or paid out.',
  'pay.noPeriodsHint': "Employer's contribution and withholding tax appear once you have approved payroll runs.",
  'pay.noOtpBasisHint': 'The pension basis appears once you have payroll runs with pension amounts.',
  'pay.noHolidayPayHint': 'The holiday pay basis appears once you have approved payroll runs in the selected period.',
  'pay.noPayslipsHint': 'Payslips appear once the payroll run has employees.',
  'pay.noInboxVouchersHint': 'Vouchers that have not yet been booked appear here.',
  'pay.noEntriesHint': 'Accounting vouchers appear after the payroll run has been approved.',
  'pay.noFixedLinesHint': 'Add fixed salary lines to employees to use them in payroll runs.',
  'pay.salaryTypeSearchHintFull': 'Common types are shown first. Search or choose Show more for the entire active catalog.',
  'pay.overrideReasonSavedOnLineHint': 'Saved on the salary line as an audit trail.',
  'pay.salaryTypeSearchHintRest': 'Common types are shown first. Search or choose Show more for the rest.',
  'pay.overrideReasonSavedOnFixedLineHint': 'Saved on the fixed line.',
  'pay.payPeriodMonthOnlyHint': 'Payroll runs currently only support monthly periods.',
  'pay.calculationCodeOtherHint': 'Other calculation codes become available once they are implemented and verified.',
  'pay.runsAndEmployeesInline': '{{runs}} runs · {{employees}} employees',
  'pay.fteShort': 'FTE:',
  'pay.taxShort': 'Tax:',
  'pay.netShort': 'Net:',
  'pay.holidayPayShort': 'Hol. pay:',
  'pay.agaShort': 'Empl.contr.:',
  'pay.withholdingHelp': 'Withholding tax — the tax deducted from gross pay and paid to the state on the employee\'s behalf.',
  'pay.holidayPayHelp': 'Holiday pay earned — normally 10.2 % of the pay basis. Paid out the year after it is earned.',
  'pay.aga': 'Employer\'s contribution',
  'pay.agaHelp': 'Employer\'s national insurance contribution on the pay — a charge the employer pays to the state on top of the salary cost.',
  'pay.fpShort': 'Hol. pay:',
  'pay.agaOfHolidayPay': 'Contribution on hol. pay',
  'pay.agaOfHolidayPayHelp': 'Employer\'s contribution calculated on the holiday pay earned. It is accrued as the holiday pay is earned.',
  'pay.fte': 'Full-time equivalents',
  'pay.fteHelp': 'The employment share converted to whole full-time equivalents. 1.00 = a full position, 0.50 = half a position.',
  'pay.overviewFilteredSub': 'Registered pay for the financial year, filtered by payment date.',
  'pay.grouping': 'Grouping',
  'pay.perEmployee': 'Per employee',
  'pay.perSalaryType': 'Per salary type',
  'pay.employeeAndType': 'Employee and salary type',
  'pay.againstWithholding': 'Against withholding tax',
  'pay.againstAga': 'Against employer\'s contribution',
  'pay.postedAs': 'Posted as:',
  'pay.postedWithholdingOnly': '{{tax}} against 2600 withholding tax. Open before payment: {{openTax}}.',
  'pay.postedAgaOnly': '{{aga}} against 2770 employer\'s contribution. Open before payment: {{openAga}}.',
  'pay.postedBoth': '{{tax}} against 2600 withholding tax and {{aga}} against 2770 employer\'s contribution. Open before payment: {{openTax}} tax and {{openAga}} employer\'s contribution.',
  'pay.autoPostedAgainstWithholding': 'The payment is posted automatically against 2600 withholding tax, and credits the selected settlement account.',
  'pay.autoPostedAgainstAga': 'The payment is posted automatically against 2770 employer\'s contribution, and credits the selected settlement account.',
  'pay.autoPostedAgainstBoth': 'The payment is posted automatically against 2600 withholding tax and 2770 employer\'s contribution, and credits the selected settlement account.',
  'pay.agreedAnnualSalary': 'Agreed annual salary',
  'pay.agreedHourlyPay': 'Agreed hourly pay',
  'pay.withholdingSeparatePaymentNote': 'Withholding tax for salary paid from 2026 is paid separately, no later than the first business day after the payroll payment.',
  'pay.recommendedForOtpPayment': 'Recommended for OTP payment',
  'pay.otpPaymentPostingNote': 'The payment is posted to the selected settlement account and used by the Pension/OTP overview. The bank line can then be matched against the payment voucher.',
  'pay.holidayPayAccruedLastYear': 'Holiday pay, accrued last year',
  'pay.holidayPayAccruedThisYear': 'Holiday pay, accrued this year',
  'pay.ordinaryEmployment': 'Ordinary employment',
  'pay.payslipUncheckAllNote': 'Uncheck for all employees if payslips should be sent later. They can be sent from the payroll run after bookkeeping has been approved.',
  'pay.payslipPdfNotConnected': 'Payslip PDF is not connected to the backend.',
  'pay.noSalaryLines': 'No salary lines',
  'pay.deletedOn': 'Deleted {{date}}',
  'pay.payrollPaymentOn': 'Payroll payment {{date}}',
  'pay.readyLinesForPayroll': '{{count}} approved lines ready for payroll ({{amount}}).',
  'pay.noReadyLinesForPayroll': 'No approved lines ready for payroll.',
  'pay.overrideAppliesFutureRuns': 'The override applies to future payroll runs using this fixed line.',
  'pay.sentToLabel': 'is sent to',
  'pay.recommendedForPayrollPayment': 'Recommended for payroll payment',
  'pay.optionalNotePh': 'Optional note ...',
  'pay.openWithholding': 'Open withholding tax',
  'pay.openAga': 'Open employer\'s contribution',
  'pay.noPeriodPayments': 'No payments registered for the period yet.',
  'pay.advance': 'Advance',
  'pay.agaAndWithholding': 'Employer\'s contribution and withholding tax',
  'pay.agaAndWithholdingSub': 'Follow up withholding tax and employer\'s contribution from approved payroll runs per period.',
  'pay.withholdingLongHelp': 'The tax you have deducted from employees\' pay. It is held on the tax withholding account and passed on to the state — it is not yours to spend.',
  'pay.agaLongHelp': 'A charge the employer pays to the state on pay and benefits. The rate depends on which zone (municipality) the business is located in — 14.1 % in zone 1.',
  'pay.toAuthority': 'To Skatteetaten',
  'pay.toAuthorityHelp': 'Withholding tax plus employer\'s contribution — the total to be paid to the state for the period.',
  'pay.noPeriods': 'No periods yet',
  'pay.period2': 'Period',
  'pay.payrollRunShort': 'Payroll run',
  'pay.pensionOtp': 'Pension / OTP',
  'pay.pensionOtpHelp': 'Mandatory occupational pension (OTP) is legally required saving for employees\' pensions — at least 2 % of pay. Here you register and follow up payments to the pension provider from approved payroll runs.',
  'pay.pensionPayments': 'Pension payments',
  'pay.pensionPaymentsSub': 'Register and keep track of the OTP payments from approved payroll runs.',
  'pay.newPensionPayment': 'New pension payment',
  'pay.calculatedOtp': 'Calculated OTP',
  'pay.calculatedOtpHelp': 'Total calculated mandatory occupational pension for the year, from approved payroll runs.',
  'pay.open2': 'Open',
  'pay.unpaid': 'Unpaid',
  'pay.unpaidOtpHelp': 'OTP that has been calculated but not yet paid to the pension provider.',
  'pay.otp': 'OTP',
  'pay.paidOtpHelp': 'OTP that has already been paid to the pension provider.',
  'pay.otpPaidWithDifference': 'Paid {{paid}} · difference {{difference}}',
  'pay.noOtpBasis': 'No OTP basis yet',
  'pay.payPeriod': 'Pay period',
  'pay.pensionPayment': 'Pension payment',
  'pay.otpRefPh': 'E.g. OTP-06',
  'pay.holidayPayList': 'Holiday pay list',
  'pay.holidayPayListSub': 'Holiday pay earned and paid from approved payroll runs.',
  'pay.holidayPayBasis': 'Holiday pay basis',
  'pay.earned': 'Earned',
  'pay.noHolidayPay': 'No holiday pay yet',
  'pay.paymentDate': 'Payment date',
  'pay.holidayPayBasisHelp': 'The total pay that gives entitlement to holiday pay. Holiday pay is calculated as a percentage of this basis.',
  'pay.holidayPayEarnedHelp': 'Holiday pay earned so far — normally 10.2 % of the basis (12 % with five weeks of holiday). Paid out the year after it is earned.',
  'pay.holidayPayPaidHelp': 'Holiday pay already paid to employees this year.',
  'pay.voucherShort': 'Voucher:',
  'pay.paidOutShort': 'Paid:',
  'pay.earnedShort': 'Earned:',
  'pay.paidShort': 'Paid out:',
  'pay.salaryLine': 'Salary line',
  'pay.newLine': 'Create a new line',
  'pay.taxResidentCountry': 'Tax resident in country',
  'pay.earningCountry': 'Country of earning',
  'pay.earningRelation': 'Earning relationship',
  'pay.noPrefill': 'Do not prefill the amount/quantity for this line in new payroll runs',
  'pay.holidayPayPayout': 'Payment of holiday pay',
  'pay.addHolidayPay': 'Add holiday pay',
  'pay.earnedEarlier': 'Earned earlier',
  'pay.earnedThisYear': 'Earned this year',
  'pay.pensionContribution': 'Pension contribution/premium',
  'pay.registerPensionContribution': 'Register pension contribution/premium',
  'pay.fetchNavRefunds': 'Fetch refunds from NAV',
  'pay.fetchNavRefundsSub': 'Fetch refunds to be included in the payroll run.',
  'pay.emailPayslips': 'Email payslips',
  'pay.sendPayslips': 'Send payslips',
  'pay.sendLater': 'Send later',
  'pay.sendPayslip': 'Send payslip',
  'pay.sendAllPayslips': 'Send to all',
  'pay.sending': 'Sending ...',
  'pay.payslipSendFailed': 'Could not send payslip.',
  'pay.payslipSendUnavailable': 'Payslip delivery is not connected to the backend.',
  'pay.downloadPayslip': 'Download payslip',
  'pay.downloadAllPdf': 'Download all (PDF)',
  'pay.downloading': 'Downloading ...',
  'pay.sendTime': 'Time of sending',
  'pay.payslipsAfterPosting': 'Payslips can be downloaded once the payroll run has been posted.',
  'pay.noPayslipsShort': 'No payslips',
  'pay.paymentInfo': 'Payment information',
  'pay.copyToClipboard': 'Copy to clipboard',
  'pay.downloadExcel': 'Download Excel',
  'pay.registerPayment': 'Register payment',
  'pay.paymentsFromOperating': 'Payments from the operating account:',
  'pay.toBankAccount': 'To bank account',
  'pay.paidOutDate': 'Payment date',
  'pay.bankTip': 'Tip! Do not forget to make the actual payment of withholding tax and pay in your online bank.',
  'pay.linkVoucher': 'Link voucher',
  'pay.noInboxVouchers': 'No vouchers in the Inbox',
  'pay.newSalaryLine': 'New salary line',
  'pay.paidOutVerb': 'Paid out',
  'pay.agaShort2': 'Empl.contr.',
  'pay.holiday': 'Holiday',
  'pay.noExtraLines': 'No extra salary lines have been added yet.',
  'pay.showEmployeePage': 'View employee page',
  'pay.addSalaryLine': 'Add salary line',
  'pay.noEmployeesInRun': 'No employees in the payroll run',
  'pay.holidayPensionDeductions': 'Holiday pay, pension and deductions',
  'pay.pensionContributionOrPremium': 'Pension contribution or premium',
  'pay.summary': 'Summary',
  'pay.payrollRun': 'Payroll run',
  'pay.agaRate': 'Empl. contribution (14.1 %)',
  'pay.posting': 'Posting',
  'pay.writeComment': 'Write a comment',
  'pay.seePayslips': 'View payslips',
  'pay.nextStep': 'Next step',
  'pay.sendAmeldingToAltinn': 'Send the A-melding to Altinn',
  'pay.deletePayrollRun': 'Delete payroll run',
  'pay.manualSubmission': 'Manual submission',
  'pay.sendAmelding': 'Send A-melding',
  'pay.altinnConfirmation': 'Confirmation from Altinn',
  'pay.altinnConfirmationHelp': 'Once the A-melding is sent, you wait for confirmation before the payslips are created.',
  'pay.createPayslips': 'Create payslips',
  'pay.editPayrollRun': 'Edit payroll run',
  'pay.registerPaymentToEmployees': 'Register payment to employees and tax',
  'pay.cancelPosting': 'Cancel the posting',
  'pay.cancelPostingConfirmTitle': 'Cancel the accounting entry?',
  'pay.cancelPostingConfirmMessage': 'This returns the payroll run to draft. Registered payments and the accounting entry are cancelled and removed from active accounting totals. You must review and approve the payroll run again.',
  'pay.cancelPostingConfirmAction': 'Cancel the accounting entry',
  'pay.keepPosting': 'Keep the accounting entry',
  'pay.seeAccountingVoucher': 'View accounting voucher',
  'pay.registerPayments': 'Register payments',
  'pay.payrollDone': 'Payroll is run and posted!',
  'pay.payrollDoneSub': 'The payroll run has been filed, posted and recorded as paid.',
  'pay.allPayrollRuns': 'All payroll runs',
  'pay.noEntries': 'No entries',
  'pay.calculatedWithholding': 'Calculated withholding tax',
  'pay.toPayOut': 'To be paid out',
  'pay.activePayrollRuns': 'Active payroll runs',
  'pay.runsCount': '{{count}} runs',
  'pay.employeesInActiveRuns': '{{count}} employees in active runs',
  'pay.createNewRunHint': 'Create a new payroll run to pull in employees, fixed salary lines and approved travel expenses.',
  'pay.activePayrollRunsHelp': 'A payroll run calculates pay, withholding tax, holiday pay and employer\'s contribution for a period. Active runs are in progress.',
  'pay.newPayrollRun': 'New payroll run',
  'pay.noActiveRuns': 'No active payroll runs',
  'pay.earlierPayrollRuns': 'Earlier payroll runs',
  'pay.earlierPayrollRunsHelp': 'Payroll runs whose payments have been recorded. You can open them for details, payslips and accounting vouchers.',
  'pay.orderNumberDate': 'Newest payment first',
  'pay.travelAndExpenses': 'Travel and expenses',
  'pay.createPayrollRun': 'Create a new payroll run',
  'pay.payrollRunDate': 'Payroll run date',
  'pay.payPeriodMonthHelp': 'The month the salary applies to. The payment date can be a separate date.',
  'pay.paymentDateHelp': 'The date the money is actually paid out. This does not change the payroll period.',
  'pay.paymentDatePeriodWarning': 'The payment date is outside the normal month for the payroll period. Check that the period and date are correct.',
  'pay.includeFixedLines': 'Include recurring salary lines',
  'pay.includeExpenseLines': 'Include lines for expenses',
  'pay.readyExpenseLineCount': '{count} lines ready for payment',
  'pay.payPeriodLength': 'Pay period (earning length)',
  'pay.ordinaryWithholding': 'Ordinary withholding tax',
  'pay.useTaxCard': 'Use the tax card when available',
  'pay.optionalComment': 'Optional comment',
  'pay.salaryTypesAndDeductions': 'Salary types and deductions',
  'pay.salaryTypesHelp': 'Salary types control how a salary line is treated for employer\'s contribution, withholding tax, holiday pay and pension.',
  'pay.newSalaryType': 'New salary type',
  'pay.agaLiableHelp': 'Whether the salary type is part of the basis for employer\'s contribution. Ticked = liable.',
  'pay.withholdingLiableHelp': 'Whether the salary type is subject to withholding — that is, whether advance tax should be deducted from the amount.',
  'pay.holidayPayLiableHelp': 'Whether the salary type gives a holiday pay basis — that is, whether holiday pay is earned on the amount.',
  'pay.pension': 'Pension',
  'pay.pensionLiableHelp': 'Whether the salary type is part of the basis for mandatory occupational pension (OTP).',
  'pay.rules': 'Rules',
  'pay.noLiabilityRules': 'No contribution or withholding rules',
  'pay.noEffect': 'No effect',
  'pay.bonusExamplePh': 'E.g. Bonus without holiday pay',
  'pay.benefitInKind': 'Benefit in kind',
  'pay.deduction': 'Deduction',
  'pay.taxFreeAllowance': 'Tax-free allowance',
  'pay.overrideNote': 'Changes are saved as the business\'s override of the standard type.',
  'pay.ratePerMonth': 'Rate (per month)',
  'pay.calculated': 'Calculated',
  'pay.changeCountries': 'Change country of earning/residence',
  'pay.optionalCommentPh': 'Optional comment ...',
  'pay.fixedSalaryLines': 'Recurring salary lines',
  'pay.fixedSalaryLinesSub': 'Salary lines that repeat automatically in every payroll run.',
  'pay.addFixedLine': 'Add recurring salary line',
  'pay.noFixedLines': 'No recurring salary lines',
  'pay.payrollSettings': 'Payroll settings',
  'pay.payrollSettingsSub': 'Defaults used when Plumme posts pay, employer\'s contribution, holiday pay and pension.',
  'pay.contributionAndHoliday': 'Contribution and holiday pay',
  'pay.agaZone': 'Employer\'s contribution zone',
  'pay.holidayPayRate': 'Holiday pay rate',
  'pay.pensionOtpShort': 'Pension (OTP)',
  'pay.pensionProvider': 'Pension provider',
  'pay.providerOrgNo': 'Provider company no.',
  'pay.otpRate': 'OTP rate',
  'pay.accountsAndReporting': 'Accounts and reporting',
  'pay.payrollAccount': 'Payroll account (bank)',
  'pay.withholdingAccount': 'Tax withholding account',
  'pay.firstPayrollYear': 'First year for posting payroll',
  'pay.entityNumber': 'Entity number',
  'pay.holidayPayPercent': 'Holiday pay percentage',
  'pay.holidayPayPercentHelp': 'The rate holiday pay is earned at. 10.2 % is the statutory minimum; 12 % applies where five weeks of holiday is agreed.',
  'pay.holidayPayMonth': 'Month for holiday pay',
  'pay.month.january': 'January',
  'pay.month.february': 'February',
  'pay.month.march': 'March',
  'pay.month.april': 'April',
  'pay.month.june': 'June',
  'pay.month.july': 'July',
  'pay.month.august': 'August',
  'pay.month.september': 'September',
  'pay.month.october': 'October',
  'pay.month.november': 'November',
  'pay.month.december': 'December',
  'pay.shift.none': 'No shift work',
  'pay.shift.shift': 'Shift work',
  'pay.shift.rota': 'Rota',
  'pay.shift.continuous': 'Continuous shift work',
  'pay.ordinary': 'Ordinary',
  'pay.maritime': 'Maritime',
  'pay.freelancer': 'Freelancer',
  'pay.pensionOrOtherBenefit': 'Pension or other benefit',
  'pay.municipalityAndNumber': 'Municipality and municipality number',
  'pay.pickMunicipality': 'Choose municipality',
  'pay.calculationCode': 'Calculation code',
  'pay.generalIndustries': 'General industries',
  'pay.agricultureForestry': 'Agriculture and forestry',
  'pay.fishing': 'Fishing and hunting',
  'pay.pensionProviderOtp': 'Pension provider (OTP)',
  'pay.withholdingAccounts': 'Withholding accounts',
  'pay.payoutAccount': 'Account for salary payments',
  'pay.amelding': 'A-melding',
  'pay.everyMonth': 'Every month',
  'pay.everyPayrollRun': 'At every payroll run',
  'pay.taxCardChangeAlert': 'Alert on tax card changes',
  'pay.emailPh': 'name@company.com',
  'pay.sms': 'SMS',
  'pay.savingsAccount': 'Savings account',
  'pay.withholdingMode.fiftyPercent': '50 % withholding tax',
  'pay.withholdingMode.standardHint': 'Uses the valid tax card registered on the employee. Without one, 50 % is withheld.',
  'pay.withholdingMode.taxCardHint': 'Tax cards are not fetched from the Norwegian Tax Administration automatically yet. Plumme uses the tax card registered on the employee and withholds 50 % when no valid tax card exists.',
  'pay.withholdingMode.fiftyPercentHint': 'Withholds 50 % of the taxable basis for every employee in this payroll run, regardless of tax card.',
  'pay.holidayPayPrevious.hint': 'Earned last year is calculated from last year’s approved payroll runs, minus what has already been paid out. Holiday pay earned before you started using Plumme is not included – adjust the amount with the pencil.',
  'pay.deductionAccount.label': 'Account credited with the deduction',
  'pay.deductionAccount.hint': 'Deductions passed on to others are liabilities. Choose 2610 for wage garnishment. Plumme does not report garnishment in the a-melding – the deduction must be paid on separately.',
  'pay.deductionAccount.canteen': '5919 Employee canteen cost deduction',
  'pay.deductionAccount.garnishment': '2610 Wage garnishment',
  'pay.deductionAccount.unionDues': '2650 Withheld trade union dues',
  'pay.deductionAccount.other': '2690 Other deductions',

  // Special tax rules and pension premium allocation (2026-09-27).
  'pay.taxRuleUnsupportedError': 'Plumme does not support {rule} yet – run payroll for {employee} outside Plumme.',
  'err.payroll.unsupportedTaxRule': 'An employee in the payroll run has a tax rule Plumme does not support yet. Run payroll for this employee outside Plumme.',
  'pay.taxRules.svalbard': 'Svalbard',
  'pay.taxRules.janMayen': 'Jan Mayen and the Norwegian dependencies',
  'pay.taxRules.seafarerDeduction': 'the special deduction for seafarers',
  'pay.taxRules.charity': 'charitable or non-profit organisation',
  'pay.taxRules.netPay': 'net pay',
  'pay.taxRules.netPaySeafarer': 'net pay for seafarers',
  'pay.taxRules.pensionSourceTax': 'source tax on pensions',
  'pay.taxRules.nanny': 'childminder in the child\'s home',
  'pay.taxRules.homeWork': 'paid work in the home',
  'pay.taxRules.taxFreeOrganization': 'tax-exempt organisation',
  'pay.pensionAllocation.explain': 'The premium replaces the calculated occupational pension (OTP) for the employees you choose. If you choose several, the amount is split by their OTP basis.',
  'pay.pensionAllocation.employees': 'Employees the premium applies to',
  'pay.pensionAllocation.amountRequired': 'Enter an amount greater than 0.',
  'pay.pensionAllocation.noEmployees': 'Choose at least one employee the premium applies to.',
  'pay.pensionAllocation.noBasis': 'The chosen employees have no OTP basis in this payroll run. Choose one employee, or add salary first.',
  'pay.pensionAllocation.noLines': 'The payroll run has no employees to attach the pension premium to.',
  'pay.pensionAllocation.saveFailed': 'Could not register the pension premium.',
  // Travel and expense claims paid through one run only (H9, 2026-09-27).
  'pay.travelNotPayableError': 'These travel or expense claims can no longer be paid through this payroll run: {travels}. They were already paid in another run or are not approved. Remove them from the draft, or reverse the run that paid them.',
  'err.payroll.travelNotPayable': 'A travel or expense claim in this payroll run was already paid in another run, or is no longer approved. Remove the line from the draft before approving.',

  // Payroll-pay-types.jsx i18n batch 1 (2026-09-29).
  'pay.noCalculationBasis': 'No calculation basis',
  'pay.payTypeGroup.common': 'Common',
  'pay.payTypeGroup.custom': 'Custom salary types',
  'pay.payTypeGroup.other': 'Other salary types',
  'pay.payTypeGroup.benefitInKind': 'Benefits in kind',
  'pay.payTypeGroup.deduction': 'Deductions',
  'pay.payTypeGroup.taxFreeAllowance': 'Tax-free allowances',
  'pay.inactive': 'inactive',
  'pay.selectSalaryType': 'Select salary type',
  'pay.searchSalaryTypeOrRule': 'Search by salary type or rule',
  'pay.showMoreSalaryTypes': 'Show more salary types',
  'pay.calculationRules': 'Calculation rules',

  // Payroll.jsx i18n batch 1 (2026-09-29).
  'pay.agaAndTaxTab': 'Employer contribution and tax',
  'pay.pensionOtpTab': 'Pension/OTP',
  'pay.zone': 'Zone',
  'pay.status.paid': 'Paid',
  'pay.status.unpaid': 'Unpaid',
  'pay.status.approved': 'Approved',
  'pay.status.annulled': 'Annulled',
  'pay.status.draft': 'Draft',
  'pay.status.partiallyPaid': 'Partially paid',
  'pay.select': 'Select',
  'pay.search': 'Search',
  'pay.noDataYet': 'No data yet',
  'pay.noDataYetBody': 'When there are entries, they will show up here.',
  'pay.notSet': 'Not set',
  'pay.thisIsADeduction': 'This is a deduction',
  'pay.fixedLineHint.payout': 'The line is paid out to the employee',
  'pay.fixedLineHint.taxable': 'Liable for tax - included in the withholding',
  'pay.fixedLineHint.employerContribution': 'Included in the basis for employer contribution',
  'pay.fixedLineHint.holidayPay': 'Included in the holiday pay basis',
  'pay.fixedLineHint.pension': 'Included in the basis for occupational pension (OTP)',
  'pay.fixedLineHint.deduction': 'Negative amount - deducted from the payout',
  'pay.amountMustBePositive': 'The amount must be greater than 0.',
  'pay.amountExceedsOpenTerm': 'The amount cannot be higher than the open balance for the period.',
  'pay.allocationMustMatchAmount': 'The allocation must match the amount and cannot exceed the open amount.',
  'pay.paymentUpdated': 'Payment updated.',
  'pay.paymentRegistered': 'Payment registered.',
  'pay.savePaymentFailed': 'Could not save payment.',
  'pay.paymentAnnulled': 'Payment annulled.',
  'pay.annulPaymentFailed': 'Could not annul payment.',
  'pay.allPensionPaymentsRegistered': 'All pension payments are registered.',
  'pay.noOtpToRegisterYet': 'No calculated OTP to register yet.',
  'pay.missingPayrollRunForOtp': 'Missing payroll run for the OTP payment.',
  'pay.pensionPaymentRegistered': 'Pension payment registered.',
  'pay.registerPensionPaymentFailed': 'Could not register the pension payment.',
  'pay.explainRuleOverrideRequired': 'Explain why the calculation rules are overridden.',
  'pay.navRefundsFetched': 'NAV refunds fetched.',
  'pay.navRefundsFetchFailed': 'Could not fetch refunds from NAV.',
  'pay.payslipDownloaded': 'Payslip downloaded.',
  'pay.payslipDownloadFailed': 'Could not download payslip.',
  'pay.payslipsDownloaded': 'Payslips downloaded.',
  'pay.payslipsDownloadFailed': 'Could not download payslips.',
  'pay.paymentInfoCopied': 'Payment information copied.',
  'pay.paymentFileDownloaded': 'Payment file downloaded.',
  'pay.linkInboxDocumentFailed': 'Could not link the voucher from the inbox.',
  'pay.payrollRunCreated': 'Payroll run created.',
  'pay.payrollRunCreateFailed': 'Could not create payroll run.',
  'pay.payrollRunUpdateFailed': 'Could not update the payroll run.',
  'pay.deletedPayrollRunRemoved': 'Deleted payroll run removed.',
  'pay.removePayrollRunFailed': 'Could not remove the payroll run.',
  'pay.commentSaved': 'Comment saved.',
  'pay.salaryLineAdded': 'Salary line added.',
  'pay.voucherLinkedToPayrollRun': 'Voucher linked to the payroll run.',
  'pay.salaryTypeSaved': 'Salary type saved.',
  'pay.salaryTypeSaveFailed': 'Could not save salary type.',
  'pay.fixedLineSaved': 'Fixed salary line saved.',
  'pay.fixedLineSaveFailed': 'Could not save fixed salary line.',
  'pay.fillNameAndAccountNumber': 'Fill in name and account number.',
  'pay.accountAdded': 'Account added.',
  'pay.addAccountFailed': 'Could not add account.',
  'pay.calculationCodeNotSupported': 'This employer contribution calculation code is not supported yet. Choose General industries.',
  'pay.payrollSettingsSaved': 'Payroll settings saved.',
  'pay.payrollSettingsSavedWithRecalc': 'Payroll settings saved. {count} open payroll drafts have been recalculated.',
  'pay.payrollSettingsSaveFailed': 'Could not save payroll settings.',
  'pay.markedManualSubmission': 'Marked as manual submission.',
  'pay.ameldingSentToAltinn': 'A-melding sent to Altinn.',
  'pay.payslipsCreatedAndPosted': 'Payslips created and payroll posted. Payslips can be sent later.',
  'pay.payrollRunEditableAgain': 'The payroll run can be edited again.',
  'pay.accountingAnnulled': 'The accounting entry has been annulled.',
  'pay.payrollRunAnnulled': 'Payroll run annulled.',
  'pay.payoutRegistered': 'Payout registered.',
  'pay.confirmAnnulPayment': 'Annul this payment? The accounting entry is reversed so the payment is no longer included.',
  'pay.hideDeletedPayrollRuns': 'Hide deleted payroll runs',
  'pay.showDeletedPayrollRuns': 'Show deleted payroll runs ({count})',
  'pay.removePermanently': 'Remove permanently',
  'pay.removeDeletedPayrollRunPermanently': 'Remove deleted payroll run permanently',
  'pay.confirmRemoveDeletedPayrollRunTitle': 'Remove deleted payroll run?',
  'pay.confirmRemoveDeletedPayrollRunMessage': 'This permanently removes the draft for {period}. Only payroll that has never been approved, sent or posted can be removed here.',
  'pay.editPaymentTitle': 'Edit payment',
  'pay.registerPaymentTitle': 'Register payment',
  'pay.savingEllipsis': 'Saving...',
  'pay.savePaymentAction': 'Save payment',
  'pay.editSalaryTypeTitle': 'Edit salary type',
  'pay.newFixedLineTitle': 'New fixed salary line',
  'pay.editFixedLineTitle': 'Edit fixed salary line',
  'pay.operatingAccount': 'Operating account',
  'pay.newWithholdingAccountTitle': 'New withholding tax account',
  'pay.newPayrollAccountTitle': 'New payroll account',
  'pay.addAccountAction': 'Add account',
  'pay.totalPay': 'Total pay',
  'pay.taxDeduction': 'Tax withheld',
  'pay.voucher': 'Voucher',
  'pay.basis': 'Basis',
  'pay.payrollRuns': 'Payroll runs',
  'pay.agaOfHolidayPayFull': 'Employer contribution on holiday pay',
  'pay.deadline': 'Deadline',
  'pay.paidAmount': 'Paid',
  'pay.remaining': 'Remaining',
  'pay.provider': 'Provider',
  'pay.orgNumber': 'Org. no.',
  'pay.earnedAtStandardRate': 'Earned (10.2 %)',
  'pay.ameldingRegistered': 'A-melding registered',
  'pay.noSubmissions': 'No submissions',
  'pay.posted': 'Posted',
  'pay.notPosted': 'Not posted',
  'pay.payslipsNotGenerated': 'Payslips have not been generated.',
  'pay.employmentSetOnEmployeePage': 'Employment relationship is set on the employee page',
  'pay.rulesFromSalaryType': 'Rules from the salary type',
  'pay.useStandardRules': 'Use standard rules',
  'pay.advancedSettings': 'Advanced settings',
  'pay.overrideCanChangeCalculation': 'Overriding can change tax, employer contribution, holiday pay, OTP and posting for this line.',
  'pay.removeFromFixedLines': 'Remove this from fixed salary lines',
  'pay.makeThisAFixedLine': 'Make this a fixed salary line',
  'pay.withholdingExceedsCashPayWarning': 'The withholding tax is higher than the cash pay and refunds. Add cash pay or reduce the withholding before the payroll run can be approved.',
  'pay.attachDocumentationHint': 'Attach documentation for the payroll run, for example timesheets or manual travel claims.',
  'pay.upload': 'Upload',
  'pay.step1AltinnHelp': 'Once all lines are included, the next step is to report the payroll run. The Altinn integration is connected later, so the submission can be marked as manual for now.',
  'pay.step3PayslipsHelp': 'Once the payroll run is reported and approved, payslips are created and the payroll is posted.',
  'pay.step4PaymentHelp': 'Register and post the payment of salary to employees and withholding tax to the tax authority.',
  'pay.payrollRunCompletesWhenPaid': 'The payroll run is completed once payment is registered.',
  'pay.productionSupportedProfile': 'Production-supported profile: Norwegian payroll, monthly period, General industries and percentage tax cards. Table-based tax cards, special employer contribution codes and electronic submission without a receipt are blocked.',
  'pay.searchMunicipalityOrNumber': 'Search municipality or number',
  'pay.notSupportedYet': 'not supported yet',
  'pay.chooseGeneralIndustriesWarning': 'Choose General industries before the settings can be saved. The previously chosen calculation code is not implemented.',
  'pay.searchProvider': 'Search provider',
  'pay.month.may': 'May',
  'pay.payTypeNotFixedLine': 'This salary type cannot be used as a fixed salary line.',
  'pay.calculationCodeUnsupportedShort': 'This employer contribution calculation code is not supported yet.',
  'pay.overtimePay': 'Overtime',
  'pay.mileageAllowance': 'Mileage allowance',
  'pay.driveFallback': 'Drive',
  'pay.taxableMileagePortion': 'Taxable portion',
  'pay.expenseCategoryOther': 'Other',
  'pay.overnightStayFallback': 'Overnight stay',
  'pay.hotelFallback': 'Hotel',
  'pay.mileagePayoutFallback': 'Mileage allowance',
  'pay.ownCar': 'Own car',
  'pay.travelPurposeFallback': 'Trip',
  'pay.taxTermWithholdingLabel': 'Withholding tax {{date}}',
  'pay.taxTermAgaLabel': 'Term {{term}}',
  'pay.payrollRunNotEditableForNewLines': 'An approved payroll run cannot get new salary lines.',
  'pay.payTypeNotManualEntry': 'This salary type cannot be added manually.',
  'pay.receiptInboxFallbackName': 'Voucher from the inbox',
  'pay.approvedButPayslipsFailed': 'The payroll has been posted, but the payslips were not sent: {{error}}',
  'pay.recon.runLabelPeriod': 'Payroll {{period}}',
  'pay.recon.runLabelRun': 'Run {{date}}',
  'pay.recon.notPaid': 'Not paid',
  'pay.recon.paidAfterPeriod': 'Paid after period date',
  'pay.recon.flag.negativ_netto': 'Negative net pay',
  'pay.recon.flag.mangler_skattekort': 'Missing tax card',
  'pay.recon.flag.sluttet_ansatt': 'Payment to a former employee',
  'pay.recon.flag.naturalytelse': 'Benefit in kind to review',
  'pay.recon.flag.uvanlig_endring': 'Unusual pay change',
  'pay.recon.flag.mangler_amelding': 'Missing from the A-melding',
  'pay.recon.flag.mulig_duplikat': 'Possible duplicate payment',
  'pay.recon.flag.ikke_utbetalt': 'Not paid',
  'pay.recon.unknownEmployee': 'Unknown employee',
  'pay.recon.employmentTypeFixed': 'Permanent',
  'pay.recon.reported': 'Reported',
  'pay.recon.notReported': 'Not reported',
  'pay.recon.afterPeriodDate': 'After period date',
  'pay.recon.role.forskuddstrekk': 'Withholding tax in the period',
  'pay.recon.role.aga': 'Calculated employer contribution on pay',
  'pay.recon.role.aga_feriepenger': 'Calculated employer contribution on holiday pay',
  'pay.recon.role.feriepenger': 'Holiday pay liability per the payroll system',
  'pay.recon.role.skyldig_lonn': 'Net pay and deductions from the payroll system',
  'pay.recon.role.pensjon': 'Pension premium from the payroll system',
  'pay.recon.row.brutto': 'Gross pay',
  'pay.recon.row.naturalytelser': 'Taxable benefits in kind',
  'pay.recon.row.trekkpliktige': 'Taxable deductions',
  'pay.recon.row.godtgjorelser': 'Expense allowances',
  'pay.recon.row.aga_grunnlag': 'Employer contribution basis',
  'pay.recon.row.aga': 'Calculated employer contribution',
  'pay.recon.row.netto': 'Net pay',
  'pay.recon.row.andre_trekk': 'Other deductions',
  'pay.recon.row.feriepenger': 'Holiday pay earned',
  'pay.recon.row.pensjon': 'Pension premium',
  'pay.recon.source.payrollSystem': 'Payroll system',
  'pay.recon.source.bankPayouts': 'Bank payouts',
  'pay.recon.source.pensionBasis': 'Pension basis',
  'pay.recon.source.payrollSystemDetailSingular': '{{count}} posted run in the period',
  'pay.recon.source.payrollSystemDetailPlural': '{{count}} posted runs in the period',
  'pay.recon.source.payrollSystemDetailEmpty': 'No posted payroll runs in the period',
  'pay.recon.source.ledgerDetail': '{{count}} entries on the payroll accounts',
  'pay.recon.source.ledgerDetailEmpty': 'No entries on the accounts added to the payroll area',
  'pay.recon.source.ameldingDetailNone': 'No runs to report',
  'pay.recon.source.ameldingDetailAllReported': '{{reported}} of {{total}} runs are registered as reported',
  'pay.recon.source.ameldingDetailMissing': '{{missing}} of {{total}} runs are not registered as reported',
  'pay.recon.source.bankDetailNone': 'No runs to pay',
  'pay.recon.source.bankDetailPaid': '{{paid}} of {{total}} runs are registered as paid',
  'pay.recon.source.pensionDetailPresent': 'Pension premium calculated by the payroll system',
  'pay.recon.source.pensionDetailNone': 'No pension premium in the period',
  'pay.recon.check.bokfort': 'All payroll runs are posted',
  'pay.recon.check.hovedbok': 'The payroll system matches the ledger',
  'pay.recon.check.kontrollkontoer': 'The control accounts match the basis',
  'pay.recon.check.bank': 'Net pay has been paid out',
  'pay.recon.check.amelding': 'The A-melding is registered as submitted',
  'pay.recon.check.skattekort': 'All employees have a valid tax card',
  'pay.recon.check.negativ': 'No negative net amounts',
  'pay.recon.check.duplikat': 'Possible duplicate payments are identified',
  'pay.recon.check.uvanlig': 'Unusual pay changes are identified',
  'pay.recon.check.sluttet': 'Payments to former employees are identified',
  'pay.recon.check.naturalytelse': 'Benefits in kind are analysed',
  'pay.recon.check.feriepenger': 'The holiday pay liability is reconciled',
  'pay.recon.check.termin': 'Withholding tax and employer contribution are settled',
  'pay.creatingRun': 'Creating…',
  'pay.pensionPremiumAmount': 'Actual pension premium',
  'pay.pensionBankAmount': 'Paid from bank',
  'pay.pensionFeeAmount': 'Separate fee (gross)',
  'pay.pensionFeeVat': 'VAT on fee',
  'pay.pensionFeeAccount': 'Fee expense account',
  'pay.pensionOverpaymentNotice': 'The difference is posted as a pension-provider prepayment to account 1570.',
  'pay.createLaterCorrection': 'Create correction in a later period',
  'pay.createCorrection': 'Create correction',
  'pay.laterCorrectionHelp': 'The original run is retained. Only the difference is posted when the correction is approved.',
  'pay.correctionCreated': 'The correction run was created as a draft.',
  'pay.typeStandard': 'Standard',
  'pay.typeCustom': 'Custom',
  'pay.statusInactive': 'Inactive',
  'pay.ruleTag.aga': 'Empl. contr.',
  'pay.ruleTag.tax': 'Tax',
  'pay.ruleTag.holiday': 'Hol. pay',
  'pay.ruleTag.pension': 'OTP',
  'pay.ruleTitle.aga': 'Liable for employer\'s contribution',
  'pay.ruleTitle.tax': 'Liable for withholding tax',
  'pay.ruleTitle.holiday': 'Holiday pay basis',
  'pay.ruleTitle.pension': 'Pension basis',
  'pay.stdType.monthly-salary': 'Fixed salary',
  'pay.stdType.hourly': 'Hourly pay - not overtime',
  'pay.stdType.overtime-hourly': 'Hourly pay - overtime',
  'pay.stdType.commission-pay': 'Fees, piecework, percentage or commission pay',
  'pay.stdType.bonus-holiday-pay': 'Bonus, earns holiday pay',
  'pay.stdType.bonus-no-holiday-pay': 'Bonus, does not earn holiday pay',
  'pay.stdType.board-fee': 'Board fee',
  'pay.stdType.company-car': 'Company car',
  'pay.stdType.other-benefits': 'Other benefits',
  'pay.stdType.taxable-insurance': 'Insurance, taxable portion',
  'pay.stdType.car-km-allowance': 'Mileage allowance',
  'pay.stdType.car-km-allowance-taxable': 'Mileage allowance, taxable portion',
  'pay.stdType.holiday-pay-current': 'Holiday pay earned in the current year',
  'pay.stdType.holiday-pay-previous': 'Holiday pay earned in previous years',
  'pay.stdType.pension-premium': 'Pension premium (OTP)',
  'pay.stdType.canteen-deduction': 'Canteen deduction',
  'pay.stdType.holiday-deduction': 'Deduction in pay for holiday',
  'pay.stdType.extra-tax-deduction': 'Extra tax deduction',
  'pay.stdType.employee-expense-settlement': 'Travel expense reimbursement',
  'pay.stdType.overnight-diet-hotel': 'Overnight per diem (hotel)',
});
